module.exports = __webpack_public_path__ + "img/title_prev_red.0ec14898.png";